var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgExport = function SvgExport(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    "data-width-16": 13,
    "data-width-24": 20,
    viewBox: "0 0 19.6 21.3",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M8.995.75v12.922l-2.642-2.689a.73.73 0 0 0-1.023.018.757.757 0 0 0-.018 1.042l3.93 4a.725.725 0 0 0 1.04 0l3.93-4a.757.757 0 0 0-.017-1.042.73.73 0 0 0-1.024-.018l-2.702 2.75V.75a.76.76 0 0 0-.216-.53.73.73 0 0 0-1.042 0 .76.76 0 0 0-.216.53M2.75 21.25h14a2.75 2.75 0 0 0 2.75-2.75v-3a.75.75 0 1 0-1.5 0v3a1.25 1.25 0 0 1-1.25 1.25h-14A1.25 1.25 0 0 1 1.5 18.5v-3a.75.75 0 1 0-1.5 0v3a2.75 2.75 0 0 0 2.75 2.75",
    clipRule: "evenodd"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgExport);
export default ForwardRef;